import { Component, ElementRef, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ResultsModalComponent } from "./results-modal.component";
import { ControlComponent } from "../../control.component";
import { RegLookupControl } from "../reg-lookup-control.model";
import { RegLookupControlController } from "./reg-lookup-control.controller";
import { VasAppFacade } from "../../../services/vas-app-facade.service";

@Component({
    selector: "reglookup-field",
    template: `
        <ion-input [formControl]="formControl"></ion-input>
        <button
            ion-button
            [disabled]="disabled"
            (click)="onLookup()"
        >
            Lookup
        </button>
    `,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RegLookupControlComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => RegLookupControlComponent), multi: true}
    ],
    entryComponents: [ResultsModalComponent]
})
export class RegLookupControlComponent extends ControlComponent implements ControlValueAccessor {
    @Input("value") _value = undefined;
    @Input() definition: RegLookupControl;
    @Input() formControl: FormControl;
    @Input() formGroup: FormGroup;
    @Input() assetId: string;

    @Output() changes: EventEmitter<any> = new EventEmitter();

    disabled: boolean = false;

    constructor(
        protected elemRef: ElementRef,
        protected appFacade: VasAppFacade,
        protected controller: RegLookupControlController
    ) {
        super(elemRef);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.controller
            .isDisabled(this.formControl)
            .takeUntil(this.ngUnsubscribe)
            .subscribe(disabled => this.disabled = disabled);
    }

    onLookup(): void {

        if (!this.definition.config.externalLookup) {
            this.appFacade.alert.ok(
                "Lookup not configured",
                "A lookup provider has not been configured. Please contact support if you would like to use this feature");
            return;
        }

        if (!this.formControl.value) {
            return;
        }

        const request = this.controller.getRegLookupRequest(this.formControl.value, this.definition);
        this.controller.lookup(request, this.formGroup);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/reglookup/form/reg-lookup-control.component.ts